import { useState, useEffect } from 'react';
import { api } from '@crm/shared';

let _cache = null;
let _promise = null;

export function invalidateBsaCache() {
  _cache = null;
  _promise = null;
}

export function useAllBsas() {
  const [bsas,    setBsas]    = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache) {
      setBsas(_cache);
      setLoading(false);
      return;
    }
    if (!_promise) {
      _promise = api.getAllActiveBsas()
        .then(res => {
          _cache = Array.isArray(res?.data) ? res.data : [];
          return _cache;
        })
        .catch(() => {
          _promise = null;
          return [];
        });
    }
    _promise.then(data => {
      setBsas(data);
      setLoading(false);
    });
  }, []);

  return { bsas, loading };
}
